<app-dialog-banner [dialogRef]="dialogRef" [text]="title"></app-dialog-banner>

<mat-dialog-content class="mat-typography" data-form-ready="true">

    @if (data.isValid) {
        <div class="summary valid">
            <mat-icon>check_circle</mat-icon>
            <p i18n>This schedule is valid and in sync with the unit data.</p>
        </div>
    } @else {
        <div class="summary stale">
            <mat-icon>warning</mat-icon>
            <p i18n>
                This schedule is stale and needs to be saved again. Until it is, budgets cannot be
                proposed and billing cannot be run. Saving the schedule applies the changes below.
            </p>
        </div>

        <p class="counts">{{summary}}</p>

        @if (adds.length) {
            <h4 i18n>{{adds.length}} to be added</h4>
            <table>
                <tr>
                    <th i18n>Unit</th><th i18n>Type / Category</th><th i18n>Portion</th><th i18n>Percent</th>
                </tr>
                @for (entry of adds; track entry.unitId) {
                    <tr>
                        <td>
                            @if (unitUrl(entry)) {
                                <a [routerLink]="unitUrl(entry)" target="_blank">{{unitName(entry)}}</a>
                            } @else {
                                {{unitName(entry)}}
                            }
                        </td>
                        <td>{{unitType(entry)}}</td>
                        <td class="num">{{entry.portion}}</td>
                        <td class="num">{{asPercent(entry.percent)}}</td>
                    </tr>
                }
            </table>
        }

        @if (deletes.length) {
            <h4 i18n>{{deletes.length}} to be removed</h4>
            <table>
                <tr>
                    <th i18n>Unit</th><th i18n>Type / Category</th><th i18n>Portion</th><th i18n>Percent</th>
                </tr>
                @for (entry of deletes; track entry.unitId) {
                    <tr>
                        <td>
                            @if (unitUrl(entry)) {
                                <a [routerLink]="unitUrl(entry)" target="_blank">{{unitName(entry)}}</a>
                            } @else {
                                {{unitName(entry)}}
                            }
                        </td>
                        <td>{{unitType(entry)}}</td>
                        <td class="num">{{entry.portion}}</td>
                        <td class="num">{{asPercent(entry.percent)}}</td>
                    </tr>
                }
            </table>
        }

        @if (updates.length) {
            <h4 i18n>{{updates.length}} to be updated</h4>
            <table>
                <tr>
                    <th i18n>Unit</th><th i18n>Type / Category</th>
                    <th i18n>Portion now</th><th i18n>Portion after</th>
                    <th i18n>Percent now</th><th i18n>Percent after</th>
                </tr>
                @for (entry of updates; track entry.unitId) {
                    <tr>
                        <td>
                            @if (unitUrl(entry)) {
                                <a [routerLink]="unitUrl(entry)" target="_blank">{{unitName(entry)}}</a>
                            } @else {
                                {{unitName(entry)}}
                            }
                        </td>
                        <td>{{unitType(entry)}}</td>
                        <td class="num">{{entry.oldPortion}}</td>
                        <td class="num" [class.changed]="portionChanged(entry)"
                            [class.faded]="!portionChanged(entry)">{{entry.portion}}</td>
                        <td class="num">{{asPercent(entry.oldPercent)}}</td>
                        <td class="num" [class.changed]="percentChanged(entry)"
                            [class.faded]="!percentChanged(entry)">{{asPercent(entry.percent)}}</td>
                    </tr>
                }
            </table>
        }
    }

</mat-dialog-content>

<mat-dialog-actions>
    @if (!data.isValid) {
        <button mat-raised-button color="primary" data-save-button
            [disabled]="applying" (click)="applyChanges()" i18n>Apply Changes</button>
    }
    <span class="spacer"></span>
    <button mat-button mat-dialog-close i18n>Close</button>
</mat-dialog-actions>
